<template>
    <v-app>
      <v-main>
        <v-container class="fill-height" fluid>
          <slot/>
          <v-footer padless absolute="" color="transparent">
            <v-col
              class="text-center"
              cols="12"
            >
              <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
              <a class="text-caption grey--text mx-8 text-decoration-none" @click="openContactUrl">Contact</a>
              <a class="text-caption grey--text text-decoration-none" @click="openPrivacyPolicyUrl()">Privacy & Terms</a>
            </v-col>
          </v-footer>
        </v-container>
      </v-main>
    </v-app>
</template>
<script>
import { mapGetters } from 'vuex';
  export default {
    computed: mapGetters(['contactUrl', 'privacyPolicyUrl']),
    methods: {
      openContactUrl() {
        window.open(this.contactUrl);
      },
      openPrivacyPolicyUrl() {
          window.open(this.privacyPolicyUrl);
      },
    },
  }
</script>